import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const AnimalsService = {
    list: (filter) => axios.post(API_URL + "/animals/list", filter).then(({ data: {data} }) => data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_URL + "/animals/" + id).then(({data}) => data).catch((err) => { throw err }),

    create: async (data) => axios.post(API_URL + "/animals", data).then(({data}) => data).catch((err) => { throw err }),

    edit: async (id, data) => axios.post(API_URL + "/animals/" + id, data).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_URL + "/animals/" + id).catch((err) => { throw err }),

    all: async () => axios.get(`${API_URL}/animals/get/all`).then(({data}) => data.map(d => ({label: d.text, value: d.id}))).catch((err) => { throw err })
};

export default AnimalsService;